var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "popular-section" }, [
    _c("div", { staticClass: "popular-section-inner" }, [
      _c("div", { staticClass: "tab-content popular-product-tab" }, [
        _c("div", { staticClass: "tab-pane popular-tab1" }, [
          _c("div", { staticClass: "crsl-container" }, [
            _c(
              "div",
              { staticClass: "slider" },
              [
                _vm.loading ? _c("Loader") : _vm._e(),
                _vm._v(" "),
                !_vm.loading
                  ? _c(
                      "div",
                      { staticClass: "carousel__container" },
                      [
                        _vm.products.length > 0
                          ? _c(
                              "Carousel",
                              {
                                staticClass: "popular-slider-wrap",
                                attrs: { options: _vm.options },
                                on: { click: _vm.handleClick }
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "nav-wrapper d-none d-sm-flex mb-4 pl-2"
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "carousel-title-text" },
                                      [
                                        _vm._v(
                                          "\n                    " +
                                            _vm._s(_vm.title) +
                                            "\n                  "
                                        )
                                      ]
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "nav-wrapper d-none d-md-flex justify-content-between align-items-center mb-4"
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "carousel-title-text" },
                                      [
                                        _vm._v(
                                          "\n                    " +
                                            _vm._s(_vm.title) +
                                            "\n                  "
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("CarouselChevron")
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { attrs: { "data-carousel": "wrapper" } },
                                  _vm._l(_vm.products, function(
                                    product,
                                    productIndex
                                  ) {
                                    return _c(
                                      "div",
                                      {
                                        key: productIndex,
                                        staticClass: "single-popular-product",
                                        attrs: { "data-carousel": "item" }
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "image",
                                            on: {
                                              click: function($event) {
                                                return _vm.openLink(
                                                  product.slug,
                                                  product.firstVariant.sku
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _c("img", {
                                              attrs: {
                                                title: product.fullTitle,
                                                src: _vm.optimizeImage(
                                                  product.carouselImage.url,
                                                  280
                                                ),
                                                alt: product.fullTitle,
                                                loading: "lazy"
                                              }
                                            })
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "crsl-content" },
                                          [
                                            _c(
                                              "a",
                                              {
                                                staticClass:
                                                  "text-decoration-none",
                                                attrs: {
                                                  href: "",
                                                  tabindex: "-1",
                                                  "data-disabletab": ""
                                                },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.openLink(
                                                      product.slug,
                                                      product.firstVariant.sku
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _c(
                                                  "h6",
                                                  { staticClass: "subhead-s" },
                                                  [
                                                    _vm._v(
                                                      "\n                          " +
                                                        _vm._s(
                                                          product.primaryBrand
                                                        ) +
                                                        "  \n                        "
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "h2",
                                                  {
                                                    staticClass:
                                                      "paragraph-l product-title"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                          " +
                                                        _vm._s(
                                                          product.fullTitle
                                                        ) +
                                                        "\n                        "
                                                    )
                                                  ]
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "h3",
                                              {
                                                staticClass:
                                                  "heading-3 price-heading"
                                              },
                                              [
                                                _c("Price", {
                                                  attrs: {
                                                    product: product,
                                                    user: _vm.user,
                                                    "sales-events":
                                                      _vm.salesEvents
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "a",
                                          {
                                            staticClass:
                                              "button pop-add-btn effect-black",
                                            attrs: {
                                              "data-sku":
                                                product.firstVariant.sku,
                                              "data-carousel": "cta"
                                            }
                                          },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "icon" },
                                              [
                                                _c("NsIcon", {
                                                  attrs: {
                                                    "icon-name":
                                                      "icon-addtocart",
                                                    color: "#F5F5F5",
                                                    size: "icon-md"
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              { staticClass: "text cta" },
                                              [
                                                _vm._v(
                                                  _vm._s(_vm.addToCartText)
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  }),
                                  0
                                ),
                                _vm._v(" "),
                                _c("div", {
                                  attrs: { "data-carousel": "dots" }
                                })
                              ]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  : _vm._e()
              ],
              1
            )
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }